import { Routes, Route, useLocation } from "react-router-dom";
import Layout from "../components/layout";
import Intro from "./pages/www/Intro";
import NotFound from "./pages/common/-pages/NotFound";

const Common = ({ subdomain, changeSubdomain }: { subdomain: string; changeSubdomain: (domain: string) => void }) => {
    return (
        <Layout subdomain={subdomain}>
            <Routes>
                <Route path="/" element={<Intro changeSubdomain={changeSubdomain} />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Layout>
    );
};

export default Common;
